<template lang="html">
    <div class="addGl">
        <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
            <div>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                        <li class="breadcrumb-item">
                            <router-link :to="{name: 'Dashboard'}">
                                Admin
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Account Opening Template </li>
                    </ol>
                </nav>
                <h4 class="mg-b-0 tx-spacing--1">List Of Account Opening Templates</h4>
            </div>
            <button
                  type="button"
                  class="btn btn-outline-primary"
                  @click="add()"
                >Add</button>
        </div>
                <div class="table-responsive">
                     <table class="table ml-table ml-responsive-md">
                        <thead  class="thead-primary">
                                <tr>
                             <th scope="col">No.</th>
                            <th scope="col">Code</th>
                            <th scope="col">Name</th>
                            <th scope="col">Description</th>
                             <th scope="col">Currency Code</th>
                                <th scope="col">Sub Ledger Code</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in actOpnTmpl">
                                <th scope="row">{{ index +1 }}</th>
                                <td>{{ item.template_code }}</td>
                                <td>{{ item.template_name }}</td>
                                <td>{{ item.template_description }}</td>
                                <td>{{ item.currency_code }}</td>
                                  <td>{{ item.sub_gl_code }}</td>
                                
                            </tr>
                            
                     
                        </tbody>
                        </table>
         </div>
    </div> 
  
    
</template>

<script>
export default {
    data () {
         return {
             actOpnTmpl:[]
         }

      },
    methods: {
     add() {
        this.$router.push({ name: 'accounting.actopntemplate.add' })
     },
    fetchAccountOpeningTemplate() {
         return new Promise(async (resolve, reject) => {
            try {
               let res = await req.callServerSecure({
                  resource: "entity_account_template",
                  action: "list",
                  data: {},
                  meta_data: {}
               });

               this.actOpnTmpl = res.data.result.templates;
               resolve(true)
            } catch (err) {
            }
         });
      },

    }, 
    async mounted(){
         await this.fetchAccountOpeningTemplate();
         Event.$emit('loader:show', false)
      }
    };
</script>

<style lang="less">
</style>